// extracted by mini-css-extract-plugin
export default {"title":"DiscountAndOffer_title__dw1CO"};